var map = {
	"./anm-card.png": 575,
	"./arrow.png": 576,
	"./btn-blue-m-v2.png": 577,
	"./btn-blue-m.png": 578,
	"./btn-white-m-v2.png": 579,
	"./btn-white-m.png": 580,
	"./dummy-1.png": 581,
	"./eeziepay.svg": 582,
	"./fcl.svg": 583,
	"./fpx-logo.svg": 584,
	"./game-blue.png": 585,
	"./game-img.png": 586,
	"./game-white.png": 587,
	"./global-language.svg": 588,
	"./ifm-logo.svg": 589,
	"./logo-anniversary.png": 590,
	"./logo-christmas.png": 591,
	"./logo-cny-dragon.png": 592,
	"./logo-cny.png": 593,
	"./logo-halloween.png": 594,
	"./logo-merdeka.png": 595,
	"./logo-mooncake.png": 596,
	"./logo-raya.png": 597,
	"./logo-uefa.png": 598,
	"./merchant-logo.png": 94,
	"./modal-bg.jpg": 599,
	"./number-bg.png": 600,
	"./pagcor.svg": 601,
	"./pool-bg.png": 602,
	"./side-bar-bg.png": 603,
	"./tether.svg": 604,
	"./x33-logo-wc.png": 605,
	"./x33-logo.png": 606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;